import { Alert, Box } from '@mui/material'
import { ColumnsConfigurator } from '@/components/ColumnsConfigurator'

import { useControllerActions } from '../hooks/useControllerActions'
import { useController } from '../hooks/useController'
import { MODAL_HEIGHT } from '../constants'
import { useTexts } from '../hooks/useTexts'

import { ConfigureTerritories } from './ConfigureTerritories'
import { ConfigureFormat } from './ConfigureFormat'

export function Body() {
  const {
    data: { wizardStep, columnsState, showEmptySelectionWarning, columnSelection },
  } = useController()

  const texts = useTexts()

  const { onColumnSelectionChange } = useControllerActions()

  switch (wizardStep) {
    case 'configure-territories':
      return <ConfigureTerritories />

    case 'configure-format':
      return <ConfigureFormat />

    case 'configure-columns':
      switch (columnsState.status) {
        case 'complete':
          const warningCard = showEmptySelectionWarning ? (
            <Alert severity="error">{texts.emptySelectionWarning}</Alert>
          ) : null

          return (
            <Box height={MODAL_HEIGHT}>
              <ColumnsConfigurator
                columns={columnsState.columns}
                selection={columnSelection}
                onSelectionChange={onColumnSelectionChange}
                warningCard={warningCard}
              />
            </Box>
          )

        case 'error':
          // does make sense to show an error message here?
          return null

        // this states are not possible here but they are listed for completeness
        case 'loading':
        case 'not-requested':
          return null
      }

    default:
      throw new Error(`unhandled wizard step: ${wizardStep}`)
  }
}
